import React from 'react';
import {
  FormControl,
  InputLabel,
  Select as MuiSelect,
  MenuItem,
} from '@material-ui/core';
import { useTheme } from 'styled-components';

type SelectOption = {
  value: number | string;
  text: string;
};

interface SelectProps {
  id?: string;
  label: string;
  placeholder?: string;
  options: SelectOption[];
  size: 'small' | 'medium' | undefined;
  value: string | number;
  required?: boolean;
  error?: boolean;
  onChange?: (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>,
  ) => void;
}

const Select: React.FC<SelectProps> = ({
  id,
  label,
  placeholder,
  options,
  value,
  size,
  error,
  required,
  onChange,
}) => {
  const theme = useTheme();

  return (
    <FormControl id={id} size={size} error={error}>
      <InputLabel>{label}</InputLabel>
      <MuiSelect
        required={required}
        value={value}
        onChange={onChange}
        style={{ color: theme.colors.primary }}
      >
        <MenuItem value="">
          <em>{placeholder}</em>
        </MenuItem>
        {options.map((option) => (
          <MenuItem
            value={option.value}
            selected={option.value === value}
            key={option.value}
          >
            {option.text}
          </MenuItem>
        ))}
      </MuiSelect>
    </FormControl>
  );
};

export default Select;
